import { usePetitionDetailsPageFcm } from 'src/app/pages/petitionDetails/pageContext';

export function useCampaignActionsEnabled(): boolean {
	const { campaignActionsPageConfig } = usePetitionDetailsPageFcm();
	return Boolean(campaignActionsPageConfig?.enabled);
}
